import {
    FaUser,
    FaBell,
    FaLock,
    FaPalette,
    FaLanguage,
    FaMapMarkerAlt,
    FaCreditCard,
    FaQuestionCircle,
    FaInfoCircle,
    FaSignOutAlt,
    FaTrashAlt,
    FaChevronRight,
} from "react-icons/fa";
import { FaUserShield } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import "./Settings.css";

function Settings() {

    const navigate = useNavigate();

    const accountItems = [

       {
    icon: <FaUser />,
    title: "Personal Information",
    path: "/settings/profile",
},

        {
            icon: <FaLock />,
            title: "Security",
            path: "/settings/security",
        },

        {
            icon: <FaBell />,
            title: "Notifications",
            path: "/settings/notifications",
        },

       {
    icon: <FaMapMarkerAlt />,
    title: "Saved Addresses",
    path: "/settings/addresses",
},

        {
            icon: <FaCreditCard />,
            title: "Payment Methods",
            path: "/settings/payments",
        },

    ];

    const preferenceItems = [

        {
            icon: <FaPalette />,
            title: "Appearance",
            path: "/settings/appearance",
        },

        {
            icon: <FaLanguage />,
            title: "Language",
            path: "/settings/language",
        },

      {
    icon: <FaUserShield />,
    title: "Privacy",
    path: "/settings/privacy",
},

    ];

    const supportItems = [

        {
            icon: <FaQuestionCircle />,
            title: "Help & Support",
            path: "/settings/help",
        },

        {
            icon: <FaInfoCircle />,
            title: "About HomeFoods",
            path: "/settings/about",
        },

    ];

    return (

        <div className="settings-page">

            <div className="settings-header">

                <h1>

                    Settings

                </h1>

                <p>

                    Manage your account and preferences.

                </p>

            </div>

            <div className="settings-section">

                <h3>

                    Account

                </h3>

                {

                    accountItems.map((item, index) => (

                        <button
                            key={index}
                            className="settings-item"
                            onClick={() =>
                                navigate(item.path)
                            }
                        >

                            <div className="settings-left">

                                <span className="settings-icon">

                                    {item.icon}

                                </span>

                                <span>

                                    {item.title}

                                </span>

                            </div>

                            <FaChevronRight />

                        </button>

                    ))

                }

            </div>

            <div className="settings-section">

                <h3>

                    Preferences

                </h3>

                {

                    preferenceItems.map((item, index) => (

                        <button
                            key={index}
                            className="settings-item"
                            onClick={() =>
                                navigate(item.path)
                            }
                        >

                            <div className="settings-left">

                                <span className="settings-icon">

                                    {item.icon}

                                </span>

                                <span>

                                    {item.title}

                                </span>

                            </div>

                            <FaChevronRight />

                        </button>

                    ))

                }

            </div>

            <div className="settings-section">

                <h3>

                    Support

                </h3>

                {

                    supportItems.map((item, index) => (

                        <button
                            key={index}
                            className="settings-item"
                            onClick={() =>
                                navigate(item.path)
                            }
                        >

                            <div className="settings-left">

                                <span className="settings-icon">

                                    {item.icon}

                                </span>

                                <span>

                                    {item.title}

                                </span>

                            </div>

                            <FaChevronRight />

                        </button>

                    ))

                }

            </div>

            <div className="settings-section">

                <h3>

                    Account Actions

                </h3>

               <button
    className="settings-item logout"
    onClick={() => navigate("/settings/danger-zone")}
>

                    <div className="settings-left">

                        <span className="settings-icon">

                            <FaSignOutAlt />

                        </span>

                        <span>

                            Logout

                        </span>

                    </div>

                </button>

                <button
    className="settings-item delete"
    onClick={() => navigate("/settings/danger-zone")}
>

                    <div className="settings-left">

                        <span className="settings-icon">

                            <FaTrashAlt />

                        </span>

                        <span>

                            Delete Account

                        </span>

                    </div>

                </button>

            </div>

        </div>

    );

}

export default Settings;